module.exports = __webpack_public_path__ + "img/ultof-logo.c5bb22f1.png";